import { GET_PLANTS } from '../actions/plant/types';

let initialState = [];

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_PLANTS:
            return action.payload;
        default:
            return state;
    }
}